import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=5579cd2c&scoped=true&"
import script from "./Avatar.vue?vue&type=script&lang=js&"
export * from "./Avatar.vue?vue&type=script&lang=js&"
import style0 from "@/sass/06_atoms/avatar.scss?vue&type=style&index=0&id=5579cd2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5579cd2c",
  null
  
)

export default component.exports